import { render, staticRenderFns } from "./NewContentAvailableToastr.vue?vue&type=template&id=63fd83a7&scoped=true"
import script from "./NewContentAvailableToastr.vue?vue&type=script&lang=js"
export * from "./NewContentAvailableToastr.vue?vue&type=script&lang=js"
import style0 from "./NewContentAvailableToastr.vue?vue&type=style&index=0&id=63fd83a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fd83a7",
  null
  
)

export default component.exports